import React from 'react'
import Styled from 'styled-components'


const ButtonStyled = Styled.button`
    border: none;
    background: ${(props) => props.theme.main.mainBlue};
    padding: 0.8rem 1rem;
    color: white;
    font-size: 1.2rem;
    cursor: pointer;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0s;

    :hover {
            background-color: ${(props) => props.theme.main.mainPurple};
            color: white;
    }

    :disabled {
        cursor: not-allowed;
        background: ${(props) => props.theme.main.mainBlue};
    }

    @media (max-width: 768px) {
        font-size: 1rem !important;
        font-weight: 400 !important;
    }
`

export const Button2 = Styled(ButtonStyled)`
    background: ${(props) => props.theme.main.mainPurple}
    :hover {
        background-color: ${(props) => props.theme.main.mainBlue};
    }
    :disabled {
        background: ${(props) => props.theme.main.mainPurple};
    }
`


export default (props: any) =>
    <ButtonStyled onClick={props.onClick} className={props.className} disabled={props.disabled}>
        {props.children}
    </ButtonStyled>